import { OnboardingFormFields } from '@Types/index';
import { useBoundStore } from '@Store/useBoundStore';
import { ErrorType } from '@Services/errors/errorType.ts';
import type { IErrorHandling } from '@Types/index';

export const SsnErrorMap = {
  SSN_ALREADY_EXISTS: { errorCode: 4051, errorType: ErrorType.BUSINESS_LOGIC },
  EIN_IS_NOT_SSN: { errorCode: 80010, errorType: ErrorType.BUSINESS_LOGIC },
  INVALID_SSN_FORMAT: { errorCode: 4023, errorType: ErrorType.BUSINESS_LOGIC },
  UBO_SSN_ALREADY_EXISTS: { errorCode: 41198, errorType: ErrorType.BUSINESS_LOGIC },
  SSN_DUPLICATE_TIME_RESTRICTION: { errorCode: 40512, errorType: ErrorType.BUSINESS_LOGIC },
  SSN_DUPLICATE_APPLICATION_IN_PROGRESS: { errorCode: 40513, errorType: ErrorType.BUSINESS_LOGIC },
  SSN_DUPLICATE_ACCOUNT_EXISTS: { errorCode: 40514, errorType: ErrorType.BUSINESS_LOGIC },
  SSN_DUPLICATE_FRAUD_BLOCK: { errorCode: 40515, errorType: ErrorType.BUSINESS_LOGIC },
  SSN_DUPLICATE_NON_US_IP_BLOCK: { errorCode: 40516, errorType: ErrorType.BUSINESS_LOGIC },
  SSN_DUPLICATE_TIME_RESTRICTION_NON_US: { errorCode: 405121, errorType: ErrorType.BUSINESS_LOGIC },
  SSN_DUPLICATE_APPLICATION_IN_PROGRESS_NON_US: {
    errorCode: 405131,
    errorType: ErrorType.BUSINESS_LOGIC,
  },
  SSN_DUPLICATE_ACCOUNT_EXISTS_NON_US: { errorCode: 405141, errorType: ErrorType.BUSINESS_LOGIC },
  SSN_DUPLICATE_FRAUD_BLOCK_NON_US: { errorCode: 405151, errorType: ErrorType.BUSINESS_LOGIC },
};

export const getSsnErrorsObjectMap = (): Map<number, IErrorHandling> => {
  return new Map<number, IErrorHandling>([
    [
      SsnErrorMap.SSN_ALREADY_EXISTS.errorCode,
      {
        errorCode: SsnErrorMap.SSN_ALREADY_EXISTS.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.SSN,
        callBack: () => {},
      },
    ],
    [
      SsnErrorMap.EIN_IS_NOT_SSN.errorCode,
      {
        errorCode: SsnErrorMap.EIN_IS_NOT_SSN.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.BUSINESS_EIN,
        callBack: () => {},
      },
    ],
    [
      SsnErrorMap.INVALID_SSN_FORMAT.errorCode,
      {
        errorCode: SsnErrorMap.INVALID_SSN_FORMAT.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.SSN,
        callBack: () => {},
      },
    ],
    [
      SsnErrorMap.UBO_SSN_ALREADY_EXISTS.errorCode,
      {
        errorCode: SsnErrorMap.UBO_SSN_ALREADY_EXISTS.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.SSN,
        callBack: () => {
          // Access the store to get isUsFlow and errorSlice
          const state = useBoundStore.getState();
          const { setFormFieldError } = state.errorSlice;

          // Check if it's US flow
          const isUsFlow = state.getIsUsFlow();

          if (isUsFlow) {
            // If US flow, just return without additional actions
            return;
          } else {
            // For non-US flow:
            // 1. Set error on NATIONAL_ID_NUMBER field
            setFormFieldError(
              OnboardingFormFields.PASSPORT_NUMBER,
              'Unfortunately, we are unable to add this business owner based on the details entered. Please verify their details and try again'
            );

            // 2. Clear error on SSN field
            setFormFieldError(OnboardingFormFields.SSN, '');
          }
        },
      },
    ],
    [
      SsnErrorMap.SSN_DUPLICATE_TIME_RESTRICTION.errorCode,
      {
        errorCode: SsnErrorMap.SSN_DUPLICATE_TIME_RESTRICTION.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.SSN,
        callBack: () => {},
      },
    ],
    [
      SsnErrorMap.SSN_DUPLICATE_APPLICATION_IN_PROGRESS.errorCode,
      {
        errorCode: SsnErrorMap.SSN_DUPLICATE_APPLICATION_IN_PROGRESS.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.SSN,
        callBack: () => {},
      },
    ],
    [
      SsnErrorMap.SSN_DUPLICATE_ACCOUNT_EXISTS.errorCode,
      {
        errorCode: SsnErrorMap.SSN_DUPLICATE_ACCOUNT_EXISTS.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.SSN,
        callBack: () => {},
      },
    ],
    [
      SsnErrorMap.SSN_DUPLICATE_FRAUD_BLOCK.errorCode,
      {
        errorCode: SsnErrorMap.SSN_DUPLICATE_FRAUD_BLOCK.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.SSN,
        callBack: () => {},
      },
    ],
    [
      SsnErrorMap.SSN_DUPLICATE_NON_US_IP_BLOCK.errorCode,
      {
        errorCode: SsnErrorMap.SSN_DUPLICATE_NON_US_IP_BLOCK.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.SSN,
        callBack: () => {},
      },
    ],
    [
      SsnErrorMap.SSN_DUPLICATE_TIME_RESTRICTION_NON_US.errorCode,
      {
        errorCode: SsnErrorMap.SSN_DUPLICATE_TIME_RESTRICTION_NON_US.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.PASSPORT_NUMBER,
        callBack: () => {},
      },
    ],
    [
      SsnErrorMap.SSN_DUPLICATE_APPLICATION_IN_PROGRESS_NON_US.errorCode,
      {
        errorCode: SsnErrorMap.SSN_DUPLICATE_APPLICATION_IN_PROGRESS_NON_US.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.PASSPORT_NUMBER,
        callBack: () => {},
      },
    ],
    [
      SsnErrorMap.SSN_DUPLICATE_ACCOUNT_EXISTS_NON_US.errorCode,
      {
        errorCode: SsnErrorMap.SSN_DUPLICATE_ACCOUNT_EXISTS_NON_US.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.PASSPORT_NUMBER,
        callBack: () => {},
      },
    ],
    [
      SsnErrorMap.SSN_DUPLICATE_FRAUD_BLOCK_NON_US.errorCode,
      {
        errorCode: SsnErrorMap.SSN_DUPLICATE_FRAUD_BLOCK_NON_US.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.PASSPORT_NUMBER,
        callBack: () => {},
      },
    ],
  ]);
};
